import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed top-0 left-0 z-10 h-screen w-screen bg-nucleus-lightestBlue" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "flex pb-4" }
const _hoisted_5 = { class: "mr-2 w-1/3" }
const _hoisted_6 = { class: "ml-2 w-2/3" }
const _hoisted_7 = { class: "flex items-center px-4 py-6 border-b" }
const _hoisted_8 = { class: "text-2xl" }
const _hoisted_9 = { class: "px-4 py-6 overflow-y-auto scroll-box" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "mr-2 w-1/4" }
const _hoisted_12 = { class: "ml-2 w-3/4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_HeaderMini = _resolveComponent("HeaderMini")!
  const _component_HeaderShadow = _resolveComponent("HeaderShadow")!
  const _component_ButtonSecondary = _resolveComponent("ButtonSecondary")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Input = _resolveComponent("Input")!
  const _component_SelectCountry = _resolveComponent("SelectCountry")!
  const _component_ErrorBox = _resolveComponent("ErrorBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoadingScreen, {
      loaded: _ctx.loaded,
      message: _ctx.loadingMessage
    }, null, 8, ["loaded", "message"]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_HeaderMini, {
            name: _ctx.localUser.name,
            to: {
          name: 'localUsersDetail',
          params: { userId: _ctx.localUser.userId },
        },
            text: _ctx.$t('global.defaults.user', 1),
            "no-menu": true
          }, null, 8, ["name", "to", "text"]),
          _createVNode(_component_HeaderShadow),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editLocalUser && _ctx.editLocalUser(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_ButtonSecondary, {
                    type: "button",
                    name: _ctx.$t('buttons.cancel'),
                    disabled: _ctx.loading,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pushToDetail()))
                  }, null, 8, ["name", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Button, {
                    type: "submit",
                    name: _ctx.$t('buttons.save'),
                    disabled: 
                  !_ctx.validateEmail(_ctx.localUser.email) ||
                  !_ctx.required(_ctx.localUser.name) ||
                  !_ctx.required(_ctx.localUser.phone) ||
                  !_ctx.validatePhoneNumber(
                    _ctx.localUser.countryCode,
                    _ctx.localUser.phone
                  ) ||
                  _ctx.loading
                ,
                    loading: _ctx.loading
                  }, null, 8, ["name", "disabled", "loading"])
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["bg-nucleus-white transition-all", { 'opacity-50': _ctx.loading }])
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-3xl leading-none p-2 mr-6 flex self-center transition bg-nucleus-primaryBlue text-nucleus-white rounded-full icon-user" }, null, -1)),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("global.defaults.edit")) + " " + _toDisplayString(_ctx.localUser.name), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Checkbox, {
                    id: "admin",
                    value: _ctx.localUser.role,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localUser.role) = $event)),
                    name: _ctx.$t('inputs.adminRole.label')
                  }, null, 8, ["value", "name"]),
                  _createVNode(_component_Input, {
                    id: "name",
                    value: _ctx.localUser.name,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localUser.name) = $event)),
                    "input-type": "text",
                    label: _ctx.$t('inputs.name.label'),
                    "max-length": _ctx.inputMaxLengths.name,
                    placeholder: _ctx.$t('inputs.name.placeholder'),
                    required: ""
                  }, null, 8, ["value", "label", "max-length", "placeholder"]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_SelectCountry, {
                        id: "code",
                        value: _ctx.localUser.countryCode,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localUser.countryCode) = $event)),
                        "update:value": _ctx.localUser.countryCode,
                        label: _ctx.$t('inputs.code.label'),
                        options: _ctx.countryCodes,
                        "options-common": _ctx.countryCodesCommon
                      }, null, 8, ["value", "update:value", "label", "options", "options-common"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Input, {
                        id: "phone",
                        value: _ctx.localUser.phone,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localUser.phone) = $event)),
                        "update:value": 
                      _ctx.validatePhoneNumber(
                        _ctx.localUser.countryCode,
                        _ctx.localUser.phone
                      )
                    ,
                        "input-type": "text",
                        label: _ctx.$t('inputs.phone.label'),
                        "max-length": _ctx.inputMaxLengths.phone,
                        placeholder: _ctx.$t('inputs.phone.placeholder'),
                        error: _ctx.error.phone,
                        required: ""
                      }, null, 8, ["value", "update:value", "label", "max-length", "placeholder", "error"])
                    ])
                  ])
                ])
              ], 2)
            ], 32),
            (_ctx.errorHeading || _ctx.errorContent)
              ? (_openBlock(), _createBlock(_component_ErrorBox, {
                  key: 0,
                  heading: _ctx.errorHeading,
                  content: _ctx.errorContent,
                  fixed: _ctx.errorFixed,
                  onCloseError: _cache[6] || (_cache[6] = ($event: any) => {
            _ctx.errorHeading = '';
            _ctx.errorContent = '';
          })
                }, null, 8, ["heading", "content", "fixed"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}